export enum LabelPosition {
  Before = 'before',
  After = 'after'
}
